
import React, { memo } from "react";
import { Typography } from "@mui/material";
import PropTypes from 'prop-types'

const ErrorField = memo(({
    message
}) => {
    return <Typography variant='subtitle2' color='error'>{message}</Typography>
})

ErrorField.propTypes = {
    /** Error message */
    message: PropTypes.string,
}


export default ErrorField